/* ============================================================
   MUSE DISC — How It Works JS
   - ScrollTrigger activates each step as it enters the viewport
   - Vinyl disc spins while a step is active, stops between steps
   ============================================================ */

(function () {
  const section = document.getElementById('how-it-works');
  if (!section) return;

  const steps      = section.querySelectorAll('.hiw__step');
  const vinylInner = section.querySelector('.hiw__vinyl-inner');

  // --- Mobile: skip (CSS handles visibility) ----------------
  if (window.matchMedia('(max-width: 900px)').matches) return;

  // --- Without GSAP: show all steps immediately -------------
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    steps.forEach(s => s.classList.add('is-active'));
    return;
  }

  // --- Per-step ScrollTrigger -------------------------------
  let currentActive = null;

  steps.forEach((step) => {
    ScrollTrigger.create({
      trigger: step,
      start: 'top 60%',
      end: 'bottom 40%',

      onEnter: ()      => activate(step),
      onEnterBack: ()  => activate(step),
      onLeave: ()      => deactivate(step),
      onLeaveBack: ()  => deactivate(step),
    });
  });

  function activate(step) {
    // Deactivate previous
    if (currentActive && currentActive !== step) {
      deactivate(currentActive);
    }
    step.classList.add('is-active');
    currentActive = step;

    // Start vinyl spin
    if (vinylInner) vinylInner.classList.add('is-spinning');
  }

  function deactivate(step) {
    step.classList.remove('is-active');

    // Stop vinyl if no other step is active
    const anyActive = section.querySelector('.hiw__step.is-active');
    if (!anyActive && vinylInner) vinylInner.classList.remove('is-spinning');
  }

  // --- Activate first step immediately if already in view ---
  const first = steps[0];
  if (first) {
    const rect = first.getBoundingClientRect();
    if (rect.top < window.innerHeight * 0.6) activate(first);
  }
})();
